import React, { useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { LoguedArea } from "../../../Routes.js";
import SvgIcon from "@material-ui/core/SvgIcon";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { backPage } from "../../../Routes.js";

import { NavLink } from "react-router-dom";

import Slide from "@material-ui/core/Slide";

import { findNoticeById } from "../../../data/notices";

const useStyles = makeStyles((theme) => ({
	root: {
		maxWidth: 800,
		flexGrow: 1,
		margin: "auto",
	},
}));

function Notice(props) {
	// Similar ao componentDidMount e componentDidUpdate:
	useEffect(() => {
		LoguedArea();
		backPage(props);
		document.getElementById("background").style.backgroundColor = "#2e2b84";
	}, []);

	const classes = useStyles();

	const idFromUrl = window.location.href.substring(
		window.location.href.lastIndexOf("/") + 1
	);
	const noticeData = findNoticeById(idFromUrl);

	return (
		<Slide direction="left" in={true} mountOnEnter unmountOnExit>
			<div className={classes.root}>
				<Paper
					square
					elevation={0}
					className={classes.header}
				></Paper>
				<div className={"notice-detail"}>
					{noticeData ? (
						<div className={"notice-detail-parent"}>
							<h1>
								<NavLink to={"/noticias"}>
									<SvgIcon component={ArrowBackIosIcon}>
										<path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
									</SvgIcon>
								</NavLink>
								<span className={"orange-text"}>
									{noticeData.titulo}
								</span>
							</h1>
							<div className={"notice-detail"}>
								<p
									style={{ overflowX: "scroll" }}
									dangerouslySetInnerHTML={{
										__html: noticeData.corpo,
									}}
								></p>
							</div>
						</div>
					) : (
						<div className={"notice-detail-parent"}>
							<h1>
								<NavLink to={"/noticias"}>
									<SvgIcon component={ArrowBackIosIcon}>
										<path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
									</SvgIcon>
								</NavLink>
								<span className={"orange-text"}>
									Notícia não encontrada
								</span>
							</h1>
							<label className="error-message">
								Notícia não existente.
							</label>
						</div>
					)}
				</div>
			</div>
		</Slide>
	);
}

export default Notice;
